import { useRef, useState } from "react";

import { Breadcrumb, Button, Col, Divider, Layout, message, Row } from "antd";

import axios from "axios";
import moment from "moment";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import { smallFormItemLayout } from "./../../utils/Layouts";
import { TableOutlined } from "@ant-design/icons";

const { Content } = Layout;

const transaction = "production";
const url = `/api/${transaction}/`;
const title = "Processed Report";

const initialValues = {
  period_covered: [moment().startOf("month"), moment().endOf("month")],
};
export default function ProcessedReport() {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [options, setOptions] = useState({
    customers: [],
  });

  const [loading, setLoading] = useState({
    download: false,
  });

  const report = useRef(null);

  const getReport = useCallback(({ period_covered }) => {
    if (period_covered?.[0] && period_covered?.[1]) {
      const form_data = {
        period_covered,
      };

      setLoading((prevState) => ({
        ...prevState,
        download: true,
      }));

      axios
        .post(`${url}process-report`, form_data)
        .then((response) => {
          if (response.data) {
            setLoading((prevState) => ({
              ...prevState,
              download: false,
            }));
            return window.open(`/public/reports/${response.data.filename}`);
          }
        })
        .catch((err) => {
          setLoading((prevState) => ({
            ...prevState,
            download: false,
          }));
          message.error("There was an error processing your request");
        });
    } else {
      message.error("Please select period covered");
    }
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          padding: 24,
          minHeight: 280,
          borderRadius: 10,
        }}
      >
        <span className="module-title">{title}</span>
        <Divider />
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              error={errors.period_covered}
              formItemLayout={smallFormItemLayout}
            />
          </Col>
        </Row>

        <Row>
          <Col span={12} offset={4}>
            <Button
              icon={<TableOutlined />}
              onClick={() => {
                getReport({
                  ...state,
                });
              }}
              loading={loading.download}
              disabled={loading.download}
            >
              Download to Excel
            </Button>
          </Col>
        </Row>
      </div>
    </Content>
  );
}
